
// Lazy
function BaseLazyLoader(config = {}) {
    return {
        observer: null,
        options: {
            root: null,
            rootMargin: '0px',
            threshold: 0,
            ...config.options,
        },

        selector: config.selector, // Required
        onLoad: config.onLoad,     // Custom reveal logic

        init(customOptions = {}) {
            const mergedOptions = { ...this.options, ...customOptions };

            document.querySelectorAll(this.selector).forEach(el => {
                // Get per-element options
                const elThreshold = parseFloat(el.getAttribute('data-lazy-threshold'));
                const elMargin = el.getAttribute('data-lazy-margin');

                const observerOptions = {
                    root: mergedOptions.root,
                    threshold: !isNaN(elThreshold) ? elThreshold : mergedOptions.threshold,
                    rootMargin: elMargin || mergedOptions.rootMargin,
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            observer.unobserve(entry.target);
                            this.reveal(entry.target);
                        }
                    });
                }, observerOptions);

                // Hide initially
                el.classList.add('lazy-hidden');
                observer.observe(el);
            });
        },

        reveal(el) {
            // Force reflow
            el.offsetHeight;

            // Apply reveal class
            el.classList.remove('lazy-hidden');
            const cls = el.getAttribute('data-lazy-class') || 'lazy-loaded';
            el.classList.add(cls);

            // Run element-specific reveal logic (e.g. image src/srcset)
            if (this.onLoad) this.onLoad(el);

            // Run callback
            const cb = el.getAttribute('data-onload');
            if (cb && typeof window[cb] === 'function') {
                window[cb](el);
            }
        }
    };
}


export const LazyDomService = BaseLazyLoader({
    selector: '[data-lazy]'
});

export const LazyImageService = BaseLazyLoader({
    selector: 'img[data-src], picture:has(source[data-srcset])',
    onLoad(el) {
        if (el.tagName === 'PICTURE') {
            const sources = el.querySelectorAll('source[data-srcset]');
            sources.forEach(source => {
                const srcset = source.getAttribute('data-srcset');
                if (srcset) {
                    source.setAttribute('srcset', srcset);
                    source.removeAttribute('data-srcset');
                }
            });

            const img = el.querySelector('img[data-src]');
            if (img) {
                img.src = img.getAttribute('data-src');
                img.removeAttribute('data-src');
                img.onload = () => {
                    el.classList.add('lazy-img-loaded');
                };
            }
        } else if (el.tagName === 'IMG') {
            el.src = el.getAttribute('data-src');
            el.removeAttribute('data-src');
            el.onload = () => {
                el.classList.add('lazy-img-loaded');
            };
        }
    }
});